import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogOut, reset } from "../features/authSlice";


const Navbar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);

    const [isActive, setisActive] = React.useState(false);

    const logout = () => {
        dispatch(LogOut());
        dispatch(reset());
        localStorage.clear();
        navigate("/");
    };

    return (


        <nav className="navbar is-white">
            <div className="container">
                <div className="navbar-brand">
                    <NavLink id="navbar-logo" className="navbar-item ml-2" to="/dashboard" >
                    </NavLink>
                    <button
                        onClick={() => {
                            setisActive(!isActive);
                        }}

                        className={`navbar-burger burger ${isActive ? "is-active" : ""}`}
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="navbarBasicExample"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                {isActive &&
                    <div id="navMenu" className={`navbar-menu ${isActive ? "is-active" : ""}`}>
                        <div className="navbar-start">
                            {isActive &&
                                <div className="navbar-start" id="item">
                                    <div className="navbar-item">
                                        <NavLink className="navbar-item" to="/dashboard"><span className="has-text-success">
                                            Dashboard
                                        </span>
                                        </NavLink>
                                    </div>
                                    <div className="navbar-item ">
                                        <NavLink className="navbar-item" to="/sensors"><span className="has-text-success">
                                            Report
                                        </span>
                                        </NavLink>
                                    </div>
                                    {user && user.role === "admin" && (
                                        <div className="navbar-item ">
                                            <NavLink className="navbar-item" to="/users"><span className="has-text-success">
                                                Users
                                            </span>
                                            </NavLink>
                                        </div>
                                    )}
                                    <div className="navbar-item mr-3">
                                        <div className="buttons">
                                            <button onClick={logout} className="button is-success">
                                                Log out
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                        </div>

                    </div>
                }
            </div>
        </nav>



    );
};

export default Navbar;